<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName?.toUpperCase() }}</p>
    </div>
    <osp-table [tblConfig]="fireTyphoonZoneTblConfig" (onRowClick)="onRowClick($event)" [selectedRow]="selectedRow"></osp-table>
    <div id="fire-typhoon-zone-maintenance-loading">
        <div class="form-loader"></div>
    </div>
    <div *ngIf="showForm" class="form-content">
        <form [formGroup]="forms.fireTyphoonZoneForm" class="form">
            <div id="fire-typhoon-zone-error-message"></div>
            <div class="form-container-grid">
                <div class="field required">
                    <label>Typhoon Zone Code</label>
                </div>
                <div class="">
                    <input formControlName="typhoonCd" maxlength="25" alphanumeric >
                </div>
                <div></div>
                <div></div>
                <div class="field required">
                    <label>Short Description</label>
                </div>
                <div class="">
                    <input formControlName="typhoonShortDesc" maxlength="50" >
                </div>
                <div class="field required">
                    <label>Active</label>
                </div>
                <div class="">
                    <select formControlName="active">
                        <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                            {{activeType.name}}
                        </option>
                    </select>
                </div>
                <div class="field required">
                    <label>Long Description</label>
                </div>
                <div class="">
                    <input formControlName="typhoonLongDesc" maxlength="1000" >
                </div>
                <div class="field">
                    <label>BPIMS Code</label>
                </div>
                <div class="">
                    <input formControlName="bmCode" maxlength="8" alphanumeric >
                </div>
                <div class="field">
                    <label>Remarks</label>
                </div>
                <div class="span">
                    <input formControlName="remarks" maxlength="1000" >
                </div>
                <div class="field">
                    <label>Last Update User</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdateUser" >
                </div>
                <div class="field">
                    <label>Last Update</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdate" >
                </div>
            </div>
        </form>
        <div class="btn-grp">
            <button *ngIf="btns.fireTyphoonZone.updateDisabled" class="btn btn2" type="button" (click)="onAdd()" [disabled]="btns.fireTyphoonZone.addDisabled" >ADD</button>
            <button *ngIf="!btns.fireTyphoonZone.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()" >UPDATE</button>
            <button class="btn btn2" type="button" [disabled]='btns.fireTyphoonZone.deleteDisabled' (click)="onDelete()" >DELETE</button>
        </div>
        <div class="mtn-title"></div>
        <div class="btn-grp">
            <button class="btn btn2" type="button" [disabled]='btns.fireTyphoonZone.saveDisabled' (click)="onSave()" >SAVE</button>
        </div>
    </div>
</div>
